import React from 'react';

export default function HighlightCard({ icon, title, text }) {
  return (
    <div style={styles.card}>
      <div style={styles.iconWrapper}>
        <span style={styles.icon}>{icon}</span>
      </div>
      <h3 style={styles.title}>{title}</h3>
      <p style={styles.text}>{text}</p>
    </div>
  );
}

const F = "'Inter', system-ui, sans-serif";

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '1.75rem 1.5rem',
    textAlign: 'center',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.05)',
    flex: '1 1 220px',
    border: '1px solid #e5e7eb',
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '56px',
    height: '56px',
    borderRadius: '10px',
    backgroundColor: '#eafbef',
    marginBottom: '1rem',
  },
  icon: { fontSize: '1.8rem', lineHeight: 1 },
  title: {
    color: '#1a1a1a',
    fontFamily: F,
    fontSize: '1rem',
    fontWeight: '600',
    marginBottom: '0.45rem',
  },
  text: {
    color: '#6b7280',
    fontFamily: F,
    fontSize: '0.9rem',
    lineHeight: '1.65',
  },
};
